import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-one-apps',
  templateUrl: './sass-one-apps.component.html',
  styleUrls: ['./sass-one-apps.component.scss']
})
export class SassOneAppsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
